module.exports = __webpack_public_path__ + "img/foto_6.4b3a55b2.jpg";